import React from 'react'
import { useSelector } from 'react-redux'
import TableV2Row from '../../CustomTableV2/row'
import { TableV2MobileHeader, TableV2MobileHeaderTd, TableV2MobileHeaderTitle, TableV2Td, TableV2TdTitle, TableV2TdTitleStatus } from '../../CustomTableV2/index.styled'
import { selectLastOrderIdByDriver } from '../../../../../../redux/selector/order'
import OrderDayCounter from '../../../TableTdElements/OrderDayCounter'
import OrderDate from '../../../TableTdElements/OrderDate'
import PlatformType from '../../../TableTdElements/PlatformType'
import CustomerData from '../../../TableTdElements/CustomerData'
import OrderPayment from '../../../TableTdElements/OrderPayment'
import OrderType from '../../../TableTdElements/OrderType'
import DriverReturnTime from '../../../TableTdElements/DriverReturnTime'
import PlatformDriverArriveTime from '../../../TableTdElements/PlatformDriverArriveTime'
import OrderStatus from '../../../TableTdElements/OrderStatus'

const UnpaidOrdersTableRow = React.memo(({ headers, columns, item, onDoubleClick, onClick, isActive }) => {
	const lastOrderIdThisDriverCompleted = useSelector(selectLastOrderIdByDriver(item.processedBy))
	const isCanceled = item?.status?.status === 'CANCELED'
	const isDisabled = isCanceled || !!item?.zNumber
	const beingPreparedOrder = ['BEING_PREPARED', 'READY'].includes(item.status.status)
	const isDeliveryByPlatform = item?.orderType === 'DELIVERY_BY_PLATFORM'
	const partnerDeliveryMetaData = item?.deliveryMetaData?.partner
	const updatedDeliveryByPlatform = !!(item?.orderType === 'DELIVERY' && partnerDeliveryMetaData?.type && partnerDeliveryMetaData?.pickupEta)
	const isPlatformDriverOrder = isDeliveryByPlatform || updatedDeliveryByPlatform
	const driverArriveTime = isDeliveryByPlatform ? item?.platformMetaData?.estimatedProcessTimestamp : partnerDeliveryMetaData?.pickupEta
	const tableTdFontLayout = 'desk-font-20 tab-font-18 mob-font-18'

	return (
		<TableV2Row headers={headers}
								columns={columns}
								onDoubleClick={onDoubleClick}
								onClick={onClick}
								isActive={isActive}
								isDisabled={isDisabled}
								testId={item.orderDayCounter}>
			<TableV2MobileHeader>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[0].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[1].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
			</TableV2MobileHeader>
			<TableV2Td data-title={headers[0].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<OrderDayCounter item={item} />
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2Td data-title={headers[1].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<OrderDate item={item} />
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2MobileHeader>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[2].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[3].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
			</TableV2MobileHeader>
			<TableV2Td data-title={headers[2].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<PlatformType item={item} />
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2Td data-title={headers[3].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<CustomerData item={item} />
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2MobileHeader>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[4].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[5].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
			</TableV2MobileHeader>
			<TableV2Td data-title={headers[4].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<OrderPayment item={item} />
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2Td data-title={headers[5].title}>
				<TableV2TdTitle className={tableTdFontLayout}>
					<OrderType item={item} />
					{lastOrderIdThisDriverCompleted === item.orderId &&
						<DriverReturnTime duration={item.customer.geoData?.duration}
															modifiedDate={item.status?.modifiedDate} />}
					{isPlatformDriverOrder && beingPreparedOrder &&
						<PlatformDriverArriveTime estimatedProcessTimestamp={driverArriveTime}
																			platform={item?.platformMetaData?.platformType} />}
				</TableV2TdTitle>
			</TableV2Td>
			<TableV2MobileHeader>
				<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{headers[6].title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
			</TableV2MobileHeader>
			<TableV2Td className="tab-col-1-3 const-color" data-title={headers[6].title}>
				<TableV2TdTitleStatus className={`${tableTdFontLayout} ` + item?.status.status}>
					<OrderStatus item={item} />
				</TableV2TdTitleStatus>
			</TableV2Td>
		</TableV2Row>
	)
})

UnpaidOrdersTableRow.displayName = 'UnpaidOrdersTableRow'
export default UnpaidOrdersTableRow
